<template>
  <v-container class="pa-6">
    <Breadcrumbs
      :headline="profile.buyerName ? profile.buyerName : profile.phone"
      :link="[{ text: 'Danh sách khách hàng', href: '/lead' }, { text: 'Thông tin cá nhân' }]"
      class="mb-6"
    />
    <LeadInfo @refresh="refresh" :authorized="isUserAuthorized" />
    <LeadExtra @refresh="refresh" :authorized="isUserAuthorized" />
    <LeadOriginInterest />
    <v-card class="mb-6" outlined>
      <div class="d-flex justify-space-between align-items-center px-6 pt-6">
        <h5 class="text-uppercase align-self-center">Giai đoạn chăm sóc</h5>
      </div>
      <v-stepper v-model="currentStep" non-linear alt-labels class="stepper" elevation="0">
        <v-stepper-header>
          <template v-for="item in LEAD_CARE_STEPS">
            <v-stepper-step
              class="py-6 clickable-step"
              :step="item.s"
              :complete="isStepComplete(item.s)"
              @click="handleStepClick(item.s)"
              :class="{ 'non-clickable-step': !isUserAuthorized }"
              :key="item.s + '--step'"
            >
              <div v-if="item.s !== 4">{{ item.t }}</div>
              <v-menu v-else v-model="showMenu" offset-y>
                <template v-slot:activator="{ on }">
                  <div class="stepper-step-content" v-on="on" :style="stepStatusStyle">
                    <span v-if="profile.status === 'succeed'">Đã nhập học</span>
                    <span v-else-if="profile.status === 'failed'">Thất bại</span>
                    <span v-else>Đã đăng kí tuyển sinh</span>
                  </div>
                </template>

                <div class="button-background">
                  <v-btn color="red" @click="setStatus('failed')" outlined small class="mr-1"> Thất bại </v-btn>
                  <v-btn color="#008000" @click="setStatus('succeed')" bloked small class="white--text elevation-0">
                    Thành công
                  </v-btn>
                </div>
              </v-menu>
            </v-stepper-step>
            <v-divider :key="item.s + '--line'" v-if="item.s !== 4" />
          </template>
        </v-stepper-header>
      </v-stepper>
      <div class="px-6 pb-6 grey--text">
        <span class="red--text">*</span> Xin vui lòng bấm vào một bước trên để thay đổi giai đoạn chăm sóc
      </div>
    </v-card>
    <LeadInCharge
      :profile="profile"
      :inCharge="users"
      :latestAppointment="latestAppointment"
      :loadingAppointments="loadingAppointments"
      @refresh="refresh"
      :authorized="isUserAuthorized"
    />
    <LeadLog />
    <LeadDeletion v-if="isUserAuthorized" class="mt-6" />

    <LeadAppointment
      ref="appointment-dialog"
      :dialog="showAppointment"
      @inputConfirmed="handleDate"
      @closeAppointment="showAppointment = false"
    />
    <LeadProduct ref="product-dialog" @refresh="refresh" />
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import LeadAppointment from './LeadAppointment.vue'
import LeadProduct from './LeadProduct.vue'
import LeadLog from './LeadLog.vue'
import LeadInfo from './LeadInfo.vue'
import LeadInCharge from './LeadInCharge.vue'
import LeadExtra from './LeadExtra.vue'
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import LeadDeletion from './LeadDeletion.vue'
import get from 'lodash-es/get'
import moment from 'moment'
import { LEAD_CARE_STEPS } from '../helpers'
import LeadOriginInterest from './LeadOriginInterest.vue'
export default {
  data() {
    return {
      LEAD_CARE_STEPS,
      //
      showAppointment: false,
      showProduct: false,
      showMenu: false,
      productsList: [],
      users: [],
      appointments: [],
      loadingAppointments: false,
    }
  },
  components: {
    Breadcrumbs,
    LeadAppointment,
    LeadLog,
    LeadProduct,
    LeadInfo,
    LeadInCharge,
    LeadExtra,
    LeadDeletion,
    LeadOriginInterest,
  },
  mounted() {
    this.fetchLeadConfig()
    this.getProfileData()
    this.getLogs()
    this.getAppointments()
    this.getProducts()
    this.getUsers()
  },
  computed: {
    ...mapGetters({ user: 'auth/user', profile: 'lead/item' }),
    isUserAuthorized() {
      const isAdmin = get(this.user, 'role.type', '') === 'manager'
      const inchargeList = get(this.profile, 'incharge', [])
      let isInchargeListEmpty = false
      let isCurrentUserInInchargeList = false
      if (Array.isArray(inchargeList) && inchargeList.length) {
        isInchargeListEmpty = true
        isCurrentUserInInchargeList = inchargeList.some(u => u.id === this.user.id)
      }
      return isAdmin || isInchargeListEmpty || isCurrentUserInInchargeList
    },
    currentStep() {
      const status = this.profile.status
      if (!status) return 0
      if (status === 'noContact') return 1
      if (status === 'appointmentSet') return 2
      if (status === 'productVerified') return 3
      return 4
    },
    stepStatusStyle() {
      if (this.profile.status === 'succeed') return { color: 'green' }
      if (this.profile.status === 'failed') return { color: 'red' }
      return {}
    },
    latestAppointment() {
      return this.appointments[0] || null
    },
  },
  methods: {
    ...mapActions({
      fetchLeadConfig: 'leadConfig/fetchConfigs',
      fetchLead: 'lead/fetchLead',
      updateLead: 'lead/updateLead',
      fetchLogs: 'leadLog/fetchLogs',
      fetchProducts: 'product/fetchProducts',
      createAppointment: 'appointment/createAppointment',
      fetchAppointments: 'appointment/fetchAppointments',
      fetchUsers: 'user/fetchUsers',
    }),
    async getProfileData() {
      this.$loading.active = true
      try {
        await this.fetchLead(this.$route.params.id)
      } catch (error) {
        console.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    isStepComplete(stepNumber) {
      return this.currentStep > stepNumber
    },
    handleStepClick(step) {
      if (!this.isUserAuthorized) return this.$alert.error('Bạn không có quyền để thực hiện thao tác này')
      if (step === 1) return this.updateStatus('noContact')
      if (step === 2) return this.openAppointment()
      if (step === 3) return this.$refs['product-dialog'].open()
      if (step === 4) return (this.showMenu = !this.showMenu)
    },
    async handleDate(data) {
      if (data.date !== '') {
        await this.updateStatus('appointmentSet')
        const appointment = await this.createAppointment({ ...data, lead: this.profile.id, inCharge: this.user.id })
        if (appointment) this.addAppointment(appointment)
        this.showAppointment = false
      } else {
        await this.updateStatus('appointmentSet')
        this.showAppointment = false
      }
    },
    async updateStatus(newStatus) {
      if (newStatus === 'succeed') {
        const missingFields = this.getMissingStudentFields()
        if (missingFields.length) {
          return this.$alert.error(`Thiếu thông tin để tạo học sinh: ${missingFields.join(', ')}`)
        }
      }
      this.$loading.active = true
      try {
        const payload = { id: this.profile.id, status: newStatus }
        if (['noContact', 'appointmentSet'].includes(newStatus)) payload.testDate = null
        const updatedLead = await this.updateLead(payload)
        if (updatedLead) {
          this.profile.status = updatedLead.status
          this.profile.testDate = updatedLead.testDate
          this.profile.studentCode = updatedLead.studentCode
        }

        this.$alert.success('Đã cập nhập trạng thái khách hàng thành công')
        this.getLogs()
      } catch (error) {
        console.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    async getLogs() {
      await this.fetchLogs({ lead: this.$route.params.id, _sort: 'time:DESC' })
    },
    async getAppointments() {
      this.loadingAppointments = true
      try {
        this.appointments = await this.fetchAppointments({
          lead: this.$route.params.id,
          _sort: 'date:DESC',
        })
      } catch (error) {
        console.error(error)
        this.$alert.error('Lỗi load thông tin lịch hẹn')
      } finally {
        this.loadingAppointments = false
      }
    },
    async getProducts() {
      this.productsList = await this.fetchProducts()
    },
    async getUsers() {
      this.users = await this.fetchUsers({ role_in: ['682d7c93f9f6e40d0ab0324e', '6569abe679c575d1488858f2'] })
    },
    refresh() {
      this.getProfileData()
      this.getLogs()
    },
    openAppointment() {
      this.showAppointment = true
    },
    setStatus(newStatus) {
      this.updateStatus(newStatus)
      this.showMenu = false
    },
    getMissingStudentFields() {
      const fields = []
      if (!get(this.profile, 'studentName')) fields.push('Họ tên học sinh')
      if (!get(this.profile, 'phone')) fields.push('SĐT PHHS')
      const studentDob = get(this.profile, 'studentDob')
      if (!studentDob) {
        fields.push('Ngày sinh')
      } else if (!moment(studentDob, ['DD/MM/YYYY', 'D/M/YYYY', moment.ISO_8601], true).isValid()) {
        fields.push('Ngày sinh không hợp lệ')
      }
      return fields
    },
    addAppointment(appointment) {
      this.appointments = [appointment, ...this.appointments].sort((a, b) => moment(b.date).diff(moment(a.date)))
    },
    stepColor() {
      const status = this.profile.status
      if (status === 'succeed') return 'green'
      if (status === 'failed') return 'red'
      return ''
    },
  },
}
</script>

<style>
@import './lead-detail-style.css';
</style>
